import axios from 'axios';

export const http = axios.create({
  headers: {
    Accept: 'application/json',
  },
});

export const removeToken = () => {
  http.defaults.headers.common.Authorization = null;
};
